
var instance = null;
let SnsProxy = require("clover/sns/SnsProxy")
let PaymentGuideManager = xClass("PaymentGuideManager");


PaymentGuideManager.getInstance = function () {
    if (!instance) {
        instance = PaymentGuideManager.new();
    }
    return instance
}
PaymentGuideManager.prototype.ctor = function () {
    var self = this;
    self.inStartpanel = false
    self.fromHandoff = false


}
PaymentGuideManager.prototype.isOpen = function () {
    var self = this;
    // return true
    
    console.log("PaymentGuideManager isOpen：SnsProxy.getInstance().allowHandoff() &&  MetaManager.isSupportPaymentGuide();", SnsProxy.getInstance().allowHandoff() ,  MetaManager.isSupportPaymentGuide())
    //验证pc接力开启的版本号 配置的开启等级及平台
    return window.mini && SnsProxy.getInstance().allowHandoff() &&  MetaManager.isSupportPaymentGuide();

}

PaymentGuideManager.prototype.setInStartpanel = function (inStartpanel) {
    var self = this;
    // return true
    
    self.inStartpanel = inStartpanel

}
PaymentGuideManager.prototype.getInStartpanel = function () {
    var self = this;
    // return true
    
    return self.inStartpanel

}

PaymentGuideManager.prototype.setFromHandoff = function (fromHandoff) {
    var self = this;
    // return true
    
    self.fromHandoff = fromHandoff

}
PaymentGuideManager.prototype.getFromHandoff = function () {
    var self = this;
    // return true
    
    return self.fromHandoff

}

PaymentGuideManager.prototype.createDCSession = function ()
{
    dcSession = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`
    return dcSession
}

PaymentGuideManager.prototype.dc4User101 = function (category, sub_category, obj){
    var self = this;
    // DCAssist.dc4User101("ios_payment","acquire_click",{type: "ad"})
    if (!self.isOpen()){
        return
    }
    console.log("dadian  dadian")
    DCAssist.dc4User101(category, sub_category, obj)

}

module.exports = PaymentGuideManager